import script from "./Home-Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Home-Index.vue?vue&type=script&setup=true&lang=js"

import "./Home-Index.vue?vue&type=style&index=0&id=16f7c2c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f7c2c3"]])

export default __exports__